import { createContext, useState, useEffect, useContext } from "react";

export const TenantConfigContext = createContext(null);

export function TenantConfigProvider({ children }) {
    const [config, setConfig] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function loadConfig() {
            try {
                const res = await fetch("/api/tenant-config");
                if (!res.ok) throw new Error("Failed to fetch tenant config");

                const data = await res.json();
                setConfig(data);
            } catch (err) {
                console.error("Tenant config failed to load:", err);
            } finally {
                setLoading(false);
            }
        }

        loadConfig();
    }, []);

    if (loading) {
        return (
            <div
                style={{
                    fontFamily: "sans-serif",
                    padding: "2rem",
                    textAlign: "center",
                    color: "#666",
                }}
            >
                Loading...
            </div>
        );
    }

    if (!config) {
        return (
            <div
                style={{
                    fontFamily: "sans-serif",
                    padding: "2rem",
                    textAlign: "center",
                    color: "red",
                }}
            >
                Error loading configuration. Please contact support.
            </div>
        );
    }

    return (
        <TenantConfigContext.Provider value={config}>
            {children}
        </TenantConfigContext.Provider>
    );
}

export function useTenantConfig() {
    const ctx = useContext(TenantConfigContext);
    if (!ctx) {
        throw new Error("useTenantConfig must be used inside TenantConfigProvider");
    }
    return ctx;
}
